// components/profesionales/CiudadesOperacion/CiudadesOperacion.js
import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import Alert from 'react-bootstrap/Alert'
import Spinner from 'react-bootstrap/Spinner'
import api from 'api/api'
import { toast } from 'react-toastify'
import MapaCoberturaCiudades from './MapaCoberturaCiudades'
import './CiudadesOperacion.css'

function CiudadesOperacion({ ciudades }) {
	const [ciudadesConPoligonos, setCiudadesConPoligonos] = useState([])
	const [loading, setLoading] = useState(false)

	// Cargar polígonos para cada ciudad
	useEffect(() => {
		if (ciudades && ciudades.length > 0) {
			const cargarPoligonos = async () => {
				setLoading(true)
				try {
					// Creamos una copia de las ciudades para actualizar con polígonos
					const ciudadesActualizadas = [...ciudades]

					// Para cada ciudad, obtenemos su polígono
					for (const ciudad of ciudadesActualizadas) {
						try {
							const { datos } = await api.get(`p/config-ciudades?id=${ciudad.id}`)
							if (datos && datos.ciudadesDisponibles && datos.ciudadesDisponibles.length > 0) {
								const ciudadConPoligono = datos.ciudadesDisponibles[0]
								// Si la ciudad tiene polígono, lo agregamos a nuestra ciudad
								if (ciudadConPoligono.poligono) {
									ciudad.poligono = ciudadConPoligono.poligono
								}
							}
						} catch (error) {
							console.error(`Error al cargar polígono para ciudad ${ciudad.id}:`, error)
							// Continuamos con las demás ciudades aunque haya error en una
						}
					}

					setCiudadesConPoligonos(ciudadesActualizadas)
				} catch (error) {
					console.error('Error al cargar polígonos:', error)
					toast.error('Error al cargar los polígonos de las ciudades')
					// En caso de error, usamos las ciudades sin polígonos
					setCiudadesConPoligonos(ciudades)
				} finally {
					setLoading(false)
				}
			}

			cargarPoligonos()
		}
	}, [ciudades])

	if (!ciudades || ciudades.length === 0) {
		return (
			<Alert variant="info">No hay ciudades de operación registradas</Alert>
		)
	}

	return (
		<Container fluid className="ciudades-operacion-container">
			<Row>
				<Col xs={12} className="mb-4">
					<Card>
						<Card.Header>
							<h5 className="mb-0">
								<i className="fa fa-map-marker-alt me-2"></i>
								Mapa de Cobertura
							</h5>
						</Card.Header>
						<Card.Body>
							{loading ? (
								<div className="text-center p-4">
									<Spinner animation="border" role="status" variant="primary" />
									<p className="mt-2">Cargando polígonos de ciudades...</p>
								</div>
							) : (
								<MapaCoberturaCiudades ciudades={ciudadesConPoligonos} />
							)}
						</Card.Body>
					</Card>
				</Col>

				<Col xs={12}>
					<Card>
						<Card.Header>
							<h5 className="mb-0">
								<i className="fa fa-city me-2"></i>
								Listado de Ciudades de Operación
							</h5>
						</Card.Header>
						<Card.Body>
							<Table striped bordered hover responsive>
								<thead>
									<tr>
										<th>#</th>
										<th>Ciudad</th>
										<th>Departamento</th>
										<th>Color</th>
										<th>Polígono</th>
									</tr>
								</thead>
								<tbody>
									{ciudadesConPoligonos.map((ciudad, index) => (
										<tr key={ciudad.id}>
											<td>{index + 1}</td>
											<td>{ciudad.nombre}</td>
											<td>{ciudad.departamento || 'No especificado'}</td>
											<td>
												<div className="d-flex align-items-center">
													<div
														className="color-preview"
														style={{ backgroundColor: ciudad.color || '#cccccc' }}
													></div>
													<span className="ms-2">{ciudad.color || 'No especificado'}</span>
												</div>
											</td>
											<td>
												{ciudad.poligono ? (
													<span className="badge bg-success">Cargado</span>
												) : (
													<span className="badge bg-secondary">No disponible</span>
												)}
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}

export default CiudadesOperacion